export function formatDate(dateStr) {
  const date = new Date(dateStr)
  const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

  return formattedDate
}

export function formatExcerpt(text) {
  if (!text) return ''

  // Strip HTML tags and decode HTML entities
  let formattedText = text.replace(/<[^>]*>/g, '').replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
  const commonAbbreviations = [
    'St.',
    'Dr.',
    'Mr.',
    'Mrs.',
    'Ms.',
    'Prof.',
    'Inc.',
    'Ltd.',
    'Co.',
    'Jr.',
    'Sr.',
    'vs.',
    'e.g.',
    'i.e.',
    'etc.'
  ]

  commonAbbreviations.forEach((abbr) => {
    const regex = new RegExp(`\\b${abbr.replace('.', '\\.')}\\s`, 'g')
    formattedText = formattedText.replace(regex, abbr.replace('.', '{PERIOD}') + ' ')
  })

  const sentences = formattedText.split(/[.!?]/)
  let firstSentence = sentences[0].trim()

  firstSentence = firstSentence.replace(/{PERIOD}/g, '.')

  const words = firstSentence.split(' ')
  if (words.length > 20) {
    formattedText = words.slice(0, 20).join(' ') + '...'
  } else {
    formattedText = firstSentence + (formattedText.length > firstSentence.length ? '.' : '')
  }

  return formattedText
}

export const formatCategoryName = (name) => {
  return name
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
